import { useNavigate } from "react-router-dom";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, Home } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { isFreelanceRole, landingPathForRole } from "@/lib/rbac";

const ROLE_MESSAGES: Record<string, string> = {
  ADMIN_OPS: "Votre rôle OPS n'autorise pas l'accès aux pages Commerciales.",
  ADMIN_SALES: "Votre rôle Commercial n'autorise pas l'accès aux pages OPS.",
  ADMIN_SUPPORT: "Votre rôle Support a accès uniquement au Dashboard, Entreprises, Messages et Support.",
  FREELANCE_SDR: "Votre accès est limité à l'espace prospection (appels, prospects, RDV).",
  FREELANCE_SALES: "Votre accès est limité à l'espace prospection (disponibilités, RDV, pipeline).",
};

export default function AccessDenied() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const roleMessage = user?.staffRole ? ROLE_MESSAGES[user.staffRole] : null;

  return (
    <AdminLayout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <AlertCircle className="h-12 w-12 text-destructive" />
            </div>
            <CardTitle>Accès refusé</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-muted-foreground">
              {roleMessage ?? "Vous n'avez pas la permission d'accéder à cette page."}
            </p>
            <p className="text-sm text-muted-foreground">
              Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.
            </p>
            <Button onClick={() => navigate(landingPathForRole(user?.staffRole))} className="w-full">
              <Home className="h-4 w-4 mr-2" />
              {isFreelanceRole(user?.staffRole) ? "Retour à mon espace" : "Retour au Dashboard"}
            </Button>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
}

